import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

class BoardMediaImageErrorForm extends FormBase {
    public getEventTarget(event: Event): Element | null {
        return this.fromEventTarget(event, Element);
    }

    public getBoardMediaArea(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.BOARD_MEDIA_AREA}"]`, HTMLElement);
    }

    public getBoardImagesGrid(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.BOARD_IMAGES_GRID}"], .board-images-grid`, HTMLElement);
    }

    public getSnsPreviewTile(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_PREVIEW_TILE}"]`, HTMLElement);
    }

    public getSnsPreviewTilesGrid(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.SNS_PREVIEW_TILES_GRID}"]`, HTMLElement);
    }

    public getPostCard(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.POST_CARD}"]`, HTMLElement);
    }

    public getImages(root: ParentNode = document): HTMLImageElement[] {
        return this.queryElements(root, `[data-role="${Roles.BOARD_MEDIA_AREA}"] img.board-image`, HTMLImageElement);
    }

    public getPlaceholder(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BOARD_MEDIA_PLACEHOLDER}"]`, HTMLElement);
    }

    public getPlaceholderText(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".placeholder-text", HTMLElement);
    }

    public getPlaceholderIcon(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".placeholder-icon", HTMLElement);
    }

    public getRenderableMedia(root: ParentNode): HTMLElement[] {
        return this.queryElements(
            root,
            `[data-role="${Roles.BOARD_IMAGES_GRID}"] .board-image, [data-role="${Roles.BOARD_VIDEO_WRAP}"], [data-role="${Roles.SNS_PREVIEW_TILE}"], [data-role="${Roles.OGP_PREVIEW_CARD}"], [data-role="${Roles.YOUTUBE_PREVIEW}"], [data-role="${Roles.FACEBOOK_PREVIEW}"]`,
            HTMLElement,
        );
    }
}

export { BoardMediaImageErrorForm };
